import { extractDiatonicChord } from '@/lib/chord';
import { degreeChart } from '@/lib/degree_chart';
import { diatonicChordLists } from '@/lib/diatonic_chord_lists';

export const keys: string[] = Object.keys(degreeChart);

/**
 * キーを予測する
 * @param chords コード
 */
export const discriminateKey = (chords: string[]): [string, number][] => {
  // ダイアトニックコードの出現回数からキーを予測する

  const diatonicChordCounter: { [key: string]: number } = {};
  Object.keys(diatonicChordLists).forEach((key) => {
    diatonicChordCounter[key] = 0;
  });

  chords.forEach((chord) => {
    const diatonicChord = extractDiatonicChord(chord);

    Object.keys(diatonicChordLists).forEach((key) => {
      const diatonicChordList = diatonicChordLists[key];

      if (Object.values(diatonicChordList).includes(diatonicChord)) {
        diatonicChordCounter[key] += 1;
      }
    });
  });

  return Object.entries(diatonicChordCounter).sort((a, b) => {
    return b[1] - a[1];
  });
};
